import { render, staticRenderFns } from "./GraphDetail14.vue?vue&type=template&id=b4d78e2c&scoped=true"
import script from "./GraphDetail14.vue?vue&type=script&lang=js"
export * from "./GraphDetail14.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d78e2c",
  null
  
)

export default component.exports